import {convertAndCheckDate} from '@/helpers'

export const isCoprolibDate = (value) => {
  if (value === '' || value === null) return true
  const regExDate = /^(?:[1-9]|[0-2][0-9]|(3)[0-1])(-| |\/|.)(?:[1-9]|(0)[1-9]|(1)[0-2])\2\b(?:\d{4}|\d{2})\b$/gm
  const regExDateShortcut = /^(?:[1-9]|[0-2][0-9]|(3)[0-1])(-| |\/|.)(?:[1-9]|(0)[1-9]|(1)[0-2])\b$/gm
  const regExDateExact = /^[0-9]{8}$/gm
  if (value.match(regExDate) || value.match(regExDateShortcut) || value.match(regExDateExact)) {
    if (convertAndCheckDate(value)) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}

export const isCoprolibNumber = (value) => {
  if (!value) return true
  const regEx = /^[+-]?([\d ]?)+([.|,]?)+(\d+)?$/gm
  return !!value.match(regEx)
}

export const isCoprolibTelNumber = (value) => {
  if (!value) return true
  const regEx = /^(([+]{1}[0-9]{2}|0|00)([0-9]{2})?[0-9]{6,14})$/gm
  return !!value.match(regEx)
}
